import { createContext as t } from "react";
const e = t({});
export {
  e as OrbitContext
};
//# sourceMappingURL=index2.js.map
